/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbReturns_item$ref = any;
export type PdpSharedBlurbReturns_item = {
    readonly blurbReturnPolicy: {
        readonly accept: unknown | null;
        readonly notifyDays: string | null;
    } | null;
    readonly " $refType": PdpSharedBlurbReturns_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbReturns_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "blurbReturnPolicy",
      "name": "returnPolicy",
      "storageKey": null,
      "args": null,
      "concreteType": "ReturnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accept",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notifyDays",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '539a4e804462921a9854e4b2df48a726';
export default node;
